import FileInputLink from "@components/core/cards/FileInputLink";
import UploadIcon from "@static/core/icons/icon-upload.svg?react";
import { File } from "@type/core/dashboard/dashboard.types";
import { FileHelper } from "@utils/helpers/file-helper";
import i18n from "i18next";
import { FunctionComponent, useRef } from "react";

interface ReplaceColumnProps {
  keyId: string;
  files: File[];
  setFiles: (files: File[]) => void;
}

const ReplaceColumn: FunctionComponent<ReplaceColumnProps> = ({
  keyId,
  files,
  setFiles,
}) => {
  const inputFilesRef = useRef<HTMLInputElement>(null);

  return (
    <FileInputLink
      inputFilesRef={inputFilesRef}
      accept="application/pdf"
      descriptionUrlTitle={i18n.t("buttons.replace")}
      url="#"
      multiple={false}
      setFiles={(newFiles: File[]) => {
        const updatedFiles = files.map((file) =>
          file.key === keyId ? newFiles[0] : file,
        );
        setFiles(FileHelper.removeNameDoublon(updatedFiles));
      }}
    >
      <UploadIcon className="icon-30 cursor-pointer" />
    </FileInputLink>
  );
};

export default ReplaceColumn;
